module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24122",
      "conversations-internal-schema": "static-1.11796",
      "head-dlb": "static-1.4210",
      "hs-test-utils": "static-1.7155",
      "hubspot-url-utils": "static-1.3433",
      "HubStyleTokens": "static-2.10677",
      "I18n": "static-7.1423",
      "jasmine-runner": "static-1.5580",
      "quartz": "static-1.5937",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.472",
      "visitor-ui-component-library": "static-1.5347",
      "enviro": "static-4.313",
      "hs-promise-rejection-tracking": "static-1.4568",
      "PortalIdParser": "static-2.291",
      "raven": "static-3.5037",
      "raven-hubspot": "static-1.5344",
      "bend-plugin-trellis-migration": "static-1.2747",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1269",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3715",
      "quartz-core": "static-1.5156",
      "transmute": "static-2.29",
      "HeadJS": "static-2.605",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6579",
      "framer-motion": "static-1.45",
      "hs-test-utils-bend-plugin": "static-1.2266",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.127",
      "foundations-theming": "static-1.3477",
      "i18n-data": "static-1.203",
      "metrics-js": "static-1.8917",
      "moment-timezone": "static-5.59",
      "react-utils": "static-2.4606",
      "jasmine": "static-4.3507",
      "quartz-core-utils": "static-1.2804",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.43",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7624",
      "visitor-ui-component-library-icons": "static-1.5158",
      "rpc-client-utils": "static-1.3894",
      "ts-schema": "static-1.3395",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.118",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.677",
      "hub-http-shared-msw-handlers": "static-1.7695",
      "hubspotter-http": "static-1.3870",
      "hubspotter-http-shared-msw-handlers": "static-1.7693",
      "icons": "static-2.593",
      "mobile-manifest-mixins": "static-1.375",
      "platform-navigation-bootstrap": "static-1.11587",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15727",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "bend-plugin-foundations-components": "static-1.2848",
      "floating-ui": "static-1.33",
      "foundations-assets": "static-1.4061",
      "foundations-theming-specialty": "static-1.1194",
      "hs-story-utils": "static-1.8524",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.78",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.926",
      "bend-plugin-foundations-theming": "static-1.1960",
      "foundations-theming-base": "static-1.2462",
      "classnames": "static-2.10",
      "cssUtils": "static-1.563",
      "HubStyle": "static-2.10985",
      "sassPrefix": "static-1.137",
      "platform-infra-nav-components": "static-1.6977",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24122",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11796",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-test-utils": "/hs-test-utils/static-1.7155",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3433",
      "HubStyleTokens": "/HubStyleTokens/static-2.10677",
      "I18n": "/I18n/static-7.1423",
      "jasmine-runner": "/jasmine-runner/static-1.5580",
      "quartz": "/quartz/static-1.5937",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.472",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5347",
      "enviro": "/enviro/static-4.313",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "raven": "/raven/static-3.5037",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2747",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1269",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3715",
      "quartz-core": "/quartz-core/static-1.5156",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.605",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6579",
      "framer-motion": "/framer-motion/static-1.45",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2266",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.127",
      "foundations-theming": "/foundations-theming/static-1.3477",
      "i18n-data": "/i18n-data/static-1.203",
      "metrics-js": "/metrics-js/static-1.8917",
      "moment-timezone": "/moment-timezone/static-5.59",
      "react-utils": "/react-utils/static-2.4606",
      "jasmine": "/jasmine/static-4.3507",
      "quartz-core-utils": "/quartz-core-utils/static-1.2804",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.43",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7624",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5158",
      "rpc-client-utils": "/rpc-client-utils/static-1.3894",
      "ts-schema": "/ts-schema/static-1.3395",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.118",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.677",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7695",
      "hubspotter-http": "/hubspotter-http/static-1.3870",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7693",
      "icons": "/icons/static-2.593",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.375",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11587",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15727",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2848",
      "floating-ui": "/floating-ui/static-1.33",
      "foundations-assets": "/foundations-assets/static-1.4061",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1194",
      "hs-story-utils": "/hs-story-utils/static-1.8524",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.78",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.926",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1960",
      "foundations-theming-base": "/foundations-theming-base/static-1.2462",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.563",
      "HubStyle": "/HubStyle/static-2.10985",
      "sassPrefix": "/sassPrefix/static-1.137",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6977",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};